var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33559",
    "data-name": "Group 33559",
    transform: "translate(-650 -267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_919",
    "data-name": "Ellipse 919",
    transform: "translate(650 267)",
    fill: "none",
    stroke: "#1fac48",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33417",
    "data-name": "Group 33417",
    transform: "translate(0 -0.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_21683",
    "data-name": "Rectangle 21683",
    transform: "translate(655 277)",
    fill: "#fff",
    stroke: "#1fac48",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 1.3,
    rx: 0.65,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 0.3,
    rx: 0.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_21685",
    "data-name": "Rectangle 21685",
    transform: "translate(659.35 282.65) rotate(-90)",
    fill: "#fff",
    stroke: "#1fac48",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 1.3,
    rx: 0.65,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 0.3,
    rx: 0.15,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.e5833f5f3eb805625de4888eddad2c33.svg";
export { ForwardRef as ReactComponent };